<script setup>
import {defineProps, defineEmits, computed} from "vue";
import LinhaDeDados from "./LinhaDeDados/LinhaDeDados.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dados",
    "dadosOriginais",
    "stateDadosOriginais",
    "gerandoPagamentos",
]);

const emits = defineEmits([
    "update:alteraVisualizandoDado",
    "update:alteraLiberandoDado",
    "update:alteraAprovandoDado",
    "update:alteraGerandoPagamentos",
    "update:alteraBaixandoDado",
]);

//==================================================================//
//==================== Altera Visualizando Dado ====================//
//==================================================================//

const alteraVisualizandoDado = (update = {})=>{

    emits('update:alteraVisualizandoDado',update);

};

//==================================================================//
//====================== Altera Liberando Dado =====================//
//==================================================================//

const alteraLiberandoDado = (update = {})=>{

    emits('update:alteraLiberandoDado',update);

};

//==================================================================//
//====================== Altera Aprovando Dado =====================//
//==================================================================//

const alteraAprovandoDado = (update = {})=>{

    emits('update:alteraAprovandoDado',update);

};

//==================================================================//
//=================== Altera Gerando Pagamento =====================//
//==================================================================//

const alteraGerandoPagamentos = (update = {})=>{

    emits('update:alteraGerandoPagamentos',update);

};

//==================================================================//
//======================= Altera Baixando Dado =====================//
//==================================================================//

const alteraBaixandoDado = (update = {})=>{

    emits('update:alteraBaixandoDado',update);

};

//==================================================================//
//====================== Mostra Linha de Dados =====================//
//==================================================================//

const mostraLinhaDeDados = computed(()=>{

    if(props?.stateDadosOriginais == 'Contas a Pagar Carregadas'){
        return true;
    }
    
    if(props?.stateDadosOriginais == 'Recarregando Contas a Pagar'){
        return true;
    }

    return false;

});

//==================================================================//
//===================== Mostra Mensagem Loading ====================//
//==================================================================//

const mostraMensagemLoading = computed(()=>{

    return props?.stateDadosOriginais == 'Carregando Contas a Pagar';

});

//==================================================================//
//=================== Mostra Mensagem Not Found ====================//
//==================================================================//

const mostraMensagemNotFound = computed(()=>{

    return props?.stateDadosOriginais == 'Nenhuma Conta a Pagar Encontrada';

});

</script>

<template>

    <div class="c-table__body">

        <LinhaDeDados v-for="dado in props?.dados"
            v-show="mostraLinhaDeDados"
            :key="dado.id"
            :dados="props?.dados"
            :dado="dado"
            :dadoOriginal="props?.dadosOriginais[dado?.index]"
            :gerandoPagamentos="props?.gerandoPagamentos"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
            @update:alteraLiberandoDado="alteraLiberandoDado"
            @update:alteraAprovandoDado="alteraAprovandoDado"
            @update:alteraGerandoPagamentos="alteraGerandoPagamentos"
            @update:alteraBaixandoDado="alteraBaixandoDado"
        ></LinhaDeDados>

        <div class="c-message c-message_loading"
            v-show="mostraMensagemLoading"
        >

            Carregando Contas a Pagar

            <v-progress-circular 
                color="primary" 
                indeterminate
            ></v-progress-circular>

        </div>

        <div class="c-message c-message_done"
            v-show="mostraMensagemNotFound"
        >

            Nenhuma Conta a Pagar Encontrada

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*============================ Table ===============================*/
/*==================================================================*/

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

.c-message{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:10px;
    grid-column: 1 / -1;
    padding: 20px;
}

</style>